import { RESET_STATE } from '../auth/constants';
import { TIMESHEETS_SET } from './constants';

const initialState = {};

type State = {};

type Action = {
    type: string;
    payload: any;
};

export default function (state: State = initialState, action: Action): any {
    switch (action.type) {
        case TIMESHEETS_SET:
            return {
                ...state,
                ...action.payload
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
